import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { OemService } from 'src/app/services/oem/oem.service';

@Component({
  selector: 'app-distributors-network',
  templateUrl: './distributors-network.component.html',
  styleUrls: ['./distributors-network.component.scss']
})
export class DistributorsNetworkComponent implements OnInit{ 
  @Output() viewProfileEvent = new EventEmitter<any>();
  @Input() data : any;
  @Input() brandProfileProducts: any ='Distributors';
  itemsPerPage = 9;
  products: any[] = [];
  originalData: any[] = [];
  showNoRecordsFounds: boolean = false;
  distributorDefaultLogo: string = '../../../../../assets/images/distributor-default-logo.jpg';
  isLoggedIn: boolean = true;
 
  constructor(
    private route: ActivatedRoute,
    private oemService: OemService,
    private router: Router,
    private authService: AuthService
  ) { }
  
  ngOnInit(): void {
    this.isUserLoggedIn();
    this.getAllDistributorById(this.data.id);
  }

  paginatedItems: { logo: string, distributorName: string, companyName: string, address: string, phoneCode: string, phoneNumber: string, email: string, city: string, State: string, country:string }[] = [];
  getAllDistributorById(brandId: string) {
    this.oemService.getOemDistributorById(brandId).subscribe({
      next: (response) => {
        this.products = response.data; 
        this.originalData  =response.data;
        this.paginatedItems = this.products.slice(0, this.itemsPerPage);
      },
      error: (error) => {
       
      }
    });
  }

  onPageChanged(paginatedData: any[]): void {
    this.paginatedItems = paginatedData;
  }

  filteredData = this.products;

  onFilteredData(filtered: any[]): void {
    this.filteredData = filtered;
    
    this.products = filtered;
    this.paginatedItems = this.filteredData.slice(0, this.itemsPerPage);
    if(this.paginatedItems.length == 0){ 
      this.showNoRecordsFounds = true
    } else {
      this.showNoRecordsFounds = false
    }
    
  }

  onViewProfileClick(product : any): void {
   
    
    const dataToSend = {
      id: product.distributorId,
      name: product.distributorName,
      logo : product.logo,
      url : product.url,
    };
    this.viewProfileEvent.emit(dataToSend);
    const topOfPage = document.querySelector('app-root');
    if (topOfPage) {
      topOfPage.scrollIntoView({ behavior: 'auto' });
    }
  }
  sanitizeUrl(url: string): void {
    if (!url) {
      return;
    }
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      url = 'https://' + url;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  }
  isUserLoggedIn() {
    if(this.authService.isAuthenticated() === false) {
      this.isLoggedIn = false;
    }
  }
  onLoginPage() {
    this.router.navigate(['/login']);
  }
}
